import { FC } from 'react';

import { LootboxItem } from '@/api/common';
import { formatLootboxItemTitle } from '@/modules/promotions';

import { ScWheelPrize, ScWheelPrizeBg, ScWheelPrizeName } from './styled';

interface PrizeCompProps extends LootboxItem {
  isLocked: boolean;
  isHighlighted: boolean;
  total: number;
  index: number;
}

export const PrizeComp: FC<PrizeCompProps> = ({
  isLocked,
  isHighlighted,
  total,
  index,
  bonuses,
}) => {
  return (
    <ScWheelPrize index={index} total={total}>
      <ScWheelPrizeBg total={total} isHighlighted={isHighlighted} />
      <ScWheelPrizeName isLocked={isLocked}>
        {formatLootboxItemTitle(bonuses[0].title)}
      </ScWheelPrizeName>
    </ScWheelPrize>
  );
};
